const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const DepositRenovationCancel = require('components/deposits/depositRenovationCancel/depositRenovationCancel');

// @actions
const depositsActions = require('actions/deposits');
const actionDepositsCancel = require('actions/depositsRenovationCancel');
import * as officePrintedDocumentActions from 'actions/officePrintedDocument';

class DepositRenovationCancelContainerBase extends React.Component {
    render() {
        return <DepositRenovationCancel {...this.props} />;
    }
}

DepositRenovationCancelContainerBase.propTypes = {
    immProfile: PropTypes.object.isRequired,
    immDepositsRenovationCancel: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    requestDeposits: PropTypes.func.isRequired,
    requestDepositRenovationToCancel: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    immProfile: state.profile,
    immDepositsRenovationCancel: state.depositsRenovationCancel,
    immDeposits: state.deposits,
    immAccounts: state.accounts,
    immOfficePrintedDocument: state.officePrintedDocument,
    originCountry: state.profile.get('originCountry'),
});

module.exports.constructor = DepositRenovationCancelContainerBase;
module.exports.DepositRenovationCancelContainer = connect(
    mapStateToProps,
    {
        fetchPdfToPrint: officePrintedDocumentActions.fetchPdfToPrint,
        requestDeposits: depositsActions.requestDeposits,
        requestInterveners: depositsActions.requestDepositInterveners,
        requestDepositRenovationConditions: actionDepositsCancel.requestDepositRenovationConditions,
        requestDepositRenovationToCancel: actionDepositsCancel.requestDepositRenovationToCancel,
        resetPdfToPrint: officePrintedDocumentActions.resetPdfToPrint,
        setVisibleStep: actionDepositsCancel.setVisibleStep,
        validateStep: actionDepositsCancel.validateStep,
        showCancelModal: actionDepositsCancel.showCancelModal,
    }
)(DepositRenovationCancelContainerBase);
